let partitionColor = '#FFFFFF';

export default () => partitionColor;

export const setPartitionColor = (color: string) => {
	partitionColor = color;
};
